// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import styles from './styles.js';

class Textarea extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    label: PropTypes.string,
    onChange: PropTypes.func,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    required: PropTypes.bool,
    invalidFeedback: PropTypes.string,
    width: PropTypes.number,
    placeholder: PropTypes.string,
    fixedWidth: PropTypes.bool,
    name: PropTypes.string.isRequired,
    style: PropTypes.string,
  };

  static defaultProps = {
    classes: {},
    label: null,
    onChange: () => { },
    minLength: 2,
    maxLength: 50,
    required: false,
    invalidFeedback: 'Invalid',
    width: null,
    placeholder: null,
    fixedWidth: false,
    style: '',
  };

  render() {
    const {
      classes,
      label,
      onChange,
      minLength,
      maxLength,
      required,
      invalidFeedback,
      fixedWidth,
      width,
      placeholder,
      name,
      style,
    } = this.props;

    const props = placeholder ? { placeholder } : {};
    const croppedWidth = width ? { width } : {};

    return (
      <label className={classes.label} htmlFor={`to${label}`}>
        {label || ' '}
        <textarea
          {...props}
          className={classNames('form-control', classes.textarea,
            fixedWidth ? classes.fixedWidth : classes.width, style)}
          style={croppedWidth}
          id={`to${label}`}
          onChange={e => onChange(e.currentTarget.value, name)}
          minLength={minLength}
          maxLength={maxLength}
          required={required}
        />
        <div className={'invalid-feedback'}>
          {invalidFeedback}
        </div>
      </label>
    );
  }
}

export default withStyles(styles)(Textarea);
